import { Link } from 'react-router-dom';
import styled from 'styled-components';

const ChangeLink = styled(Link)`
  color: #762823;
  font-size: 0.9375rem;
  font-weight: 500;
  padding: 10px 0;
  margin-left: auto;
`;

export default ChangeLink;
